import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../Utils/axiosConfig";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { closeModal } from "../modal/modal";
import { setIsLogin } from "./checkLoginSlice";
import { alert } from "../../../Utils/toast";
import { checkLoginActions } from "./checkLogin";
import { queryClient } from "../../store";
import { getCurrentLanguage } from "../../../Utils/sagaHelpers";
import Cookies from "js-cookie";

export type VerifyAuthGoogleCredentialTypes = {
  credential: string;
};

export type AuthGoogleCredentialLoadAction = {
  type: string;
  payload: VerifyAuthGoogleCredentialTypes;
};

export type AuthGoogleCredentialData = {
  data: any;
};

const AuthGoogleCredential = new ReduxFetchState<
  AuthGoogleCredentialData,
  VerifyAuthGoogleCredentialTypes,
  any
>("authGoogleCredential");

export function* watchAuthGoogleCredential(action: AuthGoogleCredentialLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: AuthGoogleCredentialData = yield axios({
      headers: { "Content-Type": "multipart/form-data" },
      url: `/api/v1/users/auth/google/credential?credential=${action.payload?.credential}`,
      method: "GET",
    });

    yield put(AuthGoogleCredential.actions.loadSuccess(data));
    yield put(setIsLogin(true));
    yield put(checkLoginActions.load());
    yield put(closeModal());
    queryClient.removeQueries({ queryKey: ["checkLogin", lang] });
    Cookies.remove("checkLogin", { domain: ".lamtakam.com" });
    queryClient.removeQueries({ queryKey: ["getProfile", lang] });
    queryClient.removeQueries({ queryKey: ["getSubscriptionPlans", lang] });
    setTimeout(() => {
      window.location.reload();
    }, 500);

    alert({ message: data?.data?.message, type: "success" });
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(AuthGoogleCredential.actions.loadFailure(e.message));
  }
}

export function* authGoogleCredentialSagas() {
  yield takeEvery(AuthGoogleCredential.actionTypes.load, watchAuthGoogleCredential);
}

export function useAuthGoogleCredential() {
  const { loading, data, ...authGoogleCredentialState } = useAppSelector(
    (state) => state.authGoogleCredential,
  );
  const dispatch = useAppDispatch();

  const dispatchAuthGoogleCredential = useCallback(
    (data: VerifyAuthGoogleCredentialTypes) => {
      dispatch(AuthGoogleCredential.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...authGoogleCredentialState,
    dispatchAuthGoogleCredential,
    authGoogleCredentialLoading: loading,
    authGoogleCredentialData: data,
  };
}

export const {
  actionTypes: authGoogleCredentialActionsTypes,
  actions: authGoogleCredentialActions,
  reducer: authGoogleCredentialReducer,
} = AuthGoogleCredential;
